import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { ticketsBundlesSlice } from "@common/redux/slices/entities.slice";
import { ITicketsBundles } from "@common/redux/types/ticketsBundles";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { TicketsBundlesCard } from "./TicketsBundlesCard/TicketsBundlesCard";
import styles from './TicketsBundlesGrid.module.scss';

export function TicketsBundlesGrid() {
  const { items, total, offset } = useSelectSlice(ticketsBundlesSlice);

  return (
    <EntitiesGrid
      <ITicketsBundles>
      entityType="ticketsbundles"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: ITicketsBundles) => <TicketsBundlesCard key={item._id} entity={item} />}
      customStyle={styles}
    />
  );
}